<!-- 解决方案卡片 -->
<template>
  <div
    :class="['ImgUrl' + num, size, ['bgImg', 'scheme']]"
    @click="gotoPage(title[num].id)"
  >
    <div v-if="size == 'big'" class="title title-big">智慧管理系统解决方案</div>
    <div v-else>
      <div class="title title-small">{{ title[num].title }}</div>
      <div class="desc-small">{{ title[num].desc }}</div>
    </div>
    <div :class="[['scheme-button'], 'scheme-button-' + size]">
      了解更多
      <CaretRightFilled class="scheme-button-icon" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { CaretRightFilled } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
export default defineComponent({
  props: {
    num: {
      type: Number,
      default: 0,
    },
    size: String,
  },
  components: { CaretRightFilled },
  name: "SchemeCard",
  setup(props, ctx) {
    const title = ref([
      { id: 0 },
      { title: "智慧水务", desc: "提高企业工作效率 实现精细化管理目的", id: 0 },
      { title: "二次供水", desc: "构建专业、个性、实用的管理系统", id: 2 },
      { title: "智慧畜牧", desc: "生态环境监管 减少粪便和污水", id: 3 },
      { title: "智慧热力", desc: "实现设备设施维护情况 规范化建档管理", id: 1 },
    ]);
    const router = useRouter();
    function gotoPage(num: any) {
      console.log(num);
      router.push({ name: "scheme", query: { num: num } });
    }
    return { title, gotoPage };
  },
});
</script>
<style scoped lang="scss">
.scheme {
  transition: all 0.5s; //控制速度，也可不加
}
.scheme:hover {
  transform: scale(1.1); //设置缩放比例
  -ms-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -o-transform: scale(1.1);
  -moz-transform: scale(1.1);
}
.big {
  width: 926px;
  height: 353px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.small {
  width: 454px;
  height: 353px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.ImgUrl0 {
  background-image: url(../assets/Frame\ 67@2x.png);
}
.ImgUrl1 {
  background-image: url(../assets/Frame\ 68@2x.png);
}
.ImgUrl2 {
  background-image: url(../assets/Frame\ 71@2x.png);
}
.ImgUrl3 {
  background-image: url(../assets/Frame\ 70@2x.png);
}
.ImgUrl4 {
  background-image: url(../assets/Frame\ 69@2x.png);
}
.title {
  font-weight: 400;
  font-size: 28px;
  color: #ffffff;
  line-height: 33px;
  &-big {
    margin-left: 60px;
    margin-top: 96px;
    margin-bottom: 72px;
  }
  &-small {
    margin-top: 72px;
    margin-bottom: 20px;
    text-align: left;
    margin-left: 48px;
  }
}
.desc-small {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 16px;
  margin-left: 48px;
  margin-bottom: 87px;
}
.scheme-button {
  width: 156px;
  height: 52px;
  background: rgba(157, 157, 157, 0.15);
  border: 1px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 19px;
  cursor: pointer;
  &-big {
    margin-left: 60px;
  }
  &-small {
    margin-left: 48px;
  }
  &-icon {
    color: #ffffff;
    font-size: 14px;
    margin-left: 13px;
    margin-top: 2px;
  }
}
</style>
